import { call, put, takeLatest } from 'redux-saga/effects';
import Axios from '../../utils/axiosInstance';

const apiUrl = process.env.REACT_APP_DATA_FILE;
const updateStatusUrl = `${process.env.REACT_APP_API_BASE_URL}api/json-file-update-status/`;

// Function to check if the file is updated
const checkUpdateStatus = () => Axios.get(updateStatusUrl);


const fetchData = () => Axios.get(apiUrl);

// Worker saga to handle the conditional fetch
function* fetchApiData() {
  try {
    // Step 1: Check if the file is updated
    // const statusResponse = yield call(checkUpdateStatus);
    // const { is_updated } = statusResponse.data;
    
    // Step 2: If not updated, fetch the data file
    const response = yield call(fetchData);
    yield put({ type: 'DATA_FILE_SUCCESS', payload: response.data });
    // if (!is_updated) {
    //   const response = yield call(fetchData);
    
    //   yield put({ type: 'DATA_FILE_SUCCESS', payload: response.data });
    // }
  } catch (error) {
    yield put({ type: 'DATA_FILE_FAILURE', error: error.message });
  }
}

// Watcher saga: watches for actions dispatched to the store and starts the worker saga
function* dataFileSaga() {
  yield takeLatest('DATA_FILE_REQUEST', fetchApiData);
}

export default dataFileSaga;
